import { AdvancedRegentsAssignmentJuneCtrl } from './advanced-regents-assignment-june.controller';

export const AdvancedRegentsAssignmentJuneComponent = {
  controller: AdvancedRegentsAssignmentJuneCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./advanced-regents-assignment-june.html'),
};
